// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.signup-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  padding: 40px;
  max-width: 500px;
  width: 100%;
}

.signup-header {
  text-align: center;
  margin-bottom: 30px;
  position: relative;
}

.signup-header h1 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 28px;
}

.signup-header p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.signup-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-group label {
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group input {
  padding: 12px;
  border: 2px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s;
  text-align: left;
  direction: ltr;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  width: 100%;
  padding-right: 35px;
}

.password-input-wrapper input::-ms-reveal,
.password-input-wrapper input::-ms-clear {
  display: none;
}

.password-input-wrapper input[type="password"]::-webkit-credentials-auto-fill-button {
  display: none !important;
  visibility: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
}

.password-toggle {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #666;
  opacity: 0.7;
  transition: opacity 0.15s ease;
  outline: none !important;
  box-shadow: none !important;
  border-radius: 0;
  -webkit-tap-highlight-color: transparent;
  -webkit-focus-ring-color: transparent;
  margin: 0;
  z-index: 1;
}

.password-toggle:focus {
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
  border: none;
}

.password-toggle:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
  border: none;
}

.password-toggle:active {
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
  border: none;
  opacity: 0.5;
}

.password-toggle:hover {
  background: transparent;
  opacity: 0.9;
}

.password-toggle svg {
  width: 16px;
  height: 16px;
  display: block;
}

.password-toggle:hover {
  opacity: 1;
}

.password-toggle:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
  border-radius: 4px;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
}

.form-group input.error {
  border-color: #e74c3c;
  text-align: left;
  direction: ltr;
}

.form-group small {
  margin-top: 5px;
  color: #666;
  font-size: 12px;
}

.checking {
  font-size: 12px;
  color: #667eea;
  margin-top: 5px;
}

.error-message {
  color: #e74c3c;
  font-size: 12px;
  margin-top: 5px;
}

.submit-error {
  background-color: #fee;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
}

.checkbox-group label.error-label {
  color: #e74c3c;
}

.checkbox-group input[type="checkbox"] {
  width: auto;
  cursor: pointer;
}

.checkbox-group a {
  color: #667eea;
  text-decoration: none;
}

.checkbox-group a:hover {
  text-decoration: underline;
}

.submit-button {
  padding: 14px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.3s;
  margin-top: 10px;
}

.submit-button:hover:not(:disabled) {
  opacity: 0.9;
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.signup-footer {
  margin-top: 20px;
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.signup-footer p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.signup-footer a {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
}

.signup-footer a:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .signup-card {
    padding: 30px 20px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/SignUp.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;EAChB,wCAAwC;EACxC,qCAAqC;EACrC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".signup-container {\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 20px;\n}\n\n.signup-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  padding: 40px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.signup-header {\n  text-align: center;\n  margin-bottom: 30px;\n  position: relative;\n}\n\n.signup-header h1 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 28px;\n}\n\n.signup-header p {\n  color: #666;\n  margin: 0;\n  font-size: 14px;\n}\n\n.signup-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.form-group label {\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-group input {\n  padding: 12px;\n  border: 2px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.3s;\n  text-align: left;\n  direction: ltr;\n}\n\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  width: 100%;\n  padding-right: 35px;\n}\n\n.password-input-wrapper input::-ms-reveal,\n.password-input-wrapper input::-ms-clear {\n  display: none;\n}\n\n.password-input-wrapper input[type=\"password\"]::-webkit-credentials-auto-fill-button {\n  display: none !important;\n  visibility: hidden;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  color: #666;\n  opacity: 0.7;\n  transition: opacity 0.15s ease;\n  outline: none !important;\n  box-shadow: none !important;\n  border-radius: 0;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-focus-ring-color: transparent;\n  margin: 0;\n  z-index: 1;\n}\n\n.password-toggle:focus {\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent;\n  border: none;\n}\n\n.password-toggle:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent;\n  border: none;\n}\n\n.password-toggle:active {\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent;\n  border: none;\n  opacity: 0.5;\n}\n\n.password-toggle:hover {\n  background: transparent;\n  opacity: 0.9;\n}\n\n.password-toggle svg {\n  width: 16px;\n  height: 16px;\n  display: block;\n}\n\n.password-toggle:hover {\n  opacity: 1;\n}\n\n.password-toggle:focus {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.form-group input.error {\n  border-color: #e74c3c;\n  text-align: left;\n  direction: ltr;\n}\n\n.form-group small {\n  margin-top: 5px;\n  color: #666;\n  font-size: 12px;\n}\n\n.checking {\n  font-size: 12px;\n  color: #667eea;\n  margin-top: 5px;\n}\n\n.error-message {\n  color: #e74c3c;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n.submit-error {\n  background-color: #fee;\n  padding: 10px;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.checkbox-group label {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.checkbox-group label.error-label {\n  color: #e74c3c;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: auto;\n  cursor: pointer;\n}\n\n.checkbox-group a {\n  color: #667eea;\n  text-decoration: none;\n}\n\n.checkbox-group a:hover {\n  text-decoration: underline;\n}\n\n.submit-button {\n  padding: 14px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.3s;\n  margin-top: 10px;\n}\n\n.submit-button:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.submit-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.signup-footer {\n  margin-top: 20px;\n  text-align: center;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.signup-footer p {\n  color: #666;\n  font-size: 14px;\n  margin: 0;\n}\n\n.signup-footer a {\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.signup-footer a:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 600px) {\n  .signup-card {\n    padding: 30px 20px;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
